export type EmailDialogsTranslation = {
  addTask: {
    relationSearch: {
      contextResourceName: string;
      contextResourceType: string;
    };
  };
};

export const emailDialogsTranslation: EmailDialogsTranslation = {
  addTask: {
    relationSearch: {
      contextResourceName: 'Nazwa obiektu, do którego przypiszesz zadanie',
      contextResourceType: 'Wybierz, aby wyszukać do czego chcesz przypisać zadanie',
    },
  },
};
